export default __webpack_public_path__ + "static/media/mission-future.1c2107ec.webp";